import { ICopyable } from '../controls/common/icopyable';
import { CriteriaSearchZone } from './enums/criteria-search-zone';
import { SearchMode } from './enums/search-mode';
import { SearchOptions } from './search-options';
import { SettingsBase } from './settings-base';

export class DocumentTypeIdentificationSettings extends SettingsBase implements ICopyable<DocumentTypeIdentificationSettings> {
    public issuer: string = null;
    public customerId: number = null;
    public identifiedDocumentTypeId: number = null;
    public searchExpression: string = null;
    public searchOptions: SearchOptions = new SearchOptions();
    public searchMode: SearchMode = SearchMode.None;
    public criteriaSearchZones: CriteriaSearchZone[] = [];

    public createCopy(): DocumentTypeIdentificationSettings {
        const instance = new DocumentTypeIdentificationSettings();
        instance.issuer = this.issuer;
        instance.customerId = this.customerId;
        instance.identifiedDocumentTypeId = this.identifiedDocumentTypeId;
        instance.searchExpression = this.searchExpression;
        instance.searchOptions = this.searchOptions;
        instance.searchMode = this.searchMode;
        instance.criteriaSearchZones = this.criteriaSearchZones;
        instance.type = this.type;

        return instance;
    }

    public static createFrom(other: any): DocumentTypeIdentificationSettings {
        const instance = new DocumentTypeIdentificationSettings();
        instance.issuer = other.issuer;
        instance.customerId = other.customerId;
        instance.identifiedDocumentTypeId = other.identifiedDocumentTypeId;
        instance.searchExpression = other.searchExpression;
        instance.searchOptions = other.searchOptions;
        instance.searchMode = other.searchMode;
        instance.criteriaSearchZones = other.criteriaSearchZones;
        instance.type = other.type;

        return instance;
    }

    public copyFrom(other: any) {
        this.issuer = other.issuer;
        this.customerId = other.customerId;
        this.identifiedDocumentTypeId = other.identifiedDocumentTypeId;
        this.searchExpression = other.searchExpression;
        this.searchOptions = other.searchOptions;
        this.searchMode = other.searchMode;
        this.criteriaSearchZones = other.criteriaSearchZones;
        this.type = other.type;
    }
}
